/**
 * Mock responses shaped like the real API (AuthController / register-company / user-invites/accept).
 * Used only when `isOnboardingScaffoldMode()` is true.
 */

function delay(ms = 400) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function baseUser(overrides = {}) {
    const id = Date.now();
    return {
        id,
        email: 'scaffold@example.com',
        name: 'Scaffold User',
        company_id: id,
        role: {
            id: 2,
            name: 'company_admin',
            display_name: 'Company Administrator',
            description: 'Scaffold',
        },
        permissions: [
            'manage_company_users',
            'manage_company_settings',
            'view_company_data',
            'manage_company_assets',
            'manage_company_projects',
            'manage_company_permissions',
            'view_document_templates',
            'render_documents',
            'view_documents',
        ],
        worksite_name: null,
        work_area_name: null,
        department_name: null,
        ...overrides,
    };
}

function resolveDisplayName({ name, first_name, last_name }) {
    if (name && String(name).trim()) return String(name).trim();
    const joined = [first_name, last_name].filter(Boolean).join(' ').trim();
    return joined || 'New User';
}

export async function mockRegisterCompany({
    company_name,
    name,
    first_name,
    last_name,
    email,
}) {
    await delay();
    const tenantId = Date.now();
    const displayName = resolveDisplayName({ name, first_name, last_name });
    const user = baseUser({
        email,
        name: displayName,
        company_id: tenantId,
    });
    return {
        success: true,
        message: 'Company registered successfully (scaffold)',
        user,
        token: `scaffold_register_${tenantId}`,
        company: {
            id: tenantId,
            company_name: company_name || 'Scaffold Company',
        },
        address_book_company_id: tenantId + 1,
    };
}

export async function mockAcceptInvite({ name, emailHint }) {
    await delay();
    const id = Date.now();
    const email = emailHint || `invited+${id}@example.com`;
    const user = baseUser({
        id,
        email,
        name: name || email.split('@')[0],
        role: {
            id: 3,
            name: 'company_user',
            display_name: 'Company User',
            description: 'Scaffold',
        },
        permissions: [
            'view_company_assets',
            'view_company_projects',
            'edit_own_profile',
            'view_document_templates',
            'render_documents',
            'view_documents',
        ],
    });
    return {
        success: true,
        message: 'Registration successful (scaffold)',
        user,
        token: `scaffold_invite_${id}`,
    };
}
